var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _path16, _path17, _path18, _path19, _circle, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle2, _circle3, _circle4, _circle5, _path27, _path28, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 242,
    viewBox: "0 0 283 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.529 155.14H277.065",
    stroke: "#528FF5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.609 162.264H282.145",
    stroke: "#528FF5",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.609 169.388H282.145",
    stroke: "#528FF5",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.609 176.511H282.145",
    stroke: "#528FF5",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M231.975 183.635H257.377",
    stroke: "#528FF5",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.797 88.2556L211.882 80.3403C210.299 84.298 213.729 86.8045 215.048 88.2556L180.221 130.998V144.454L201.592 123.083L204.362 125.458L186.949 142.871C191.381 148.254 195.919 146.169 197.634 144.454C202.384 139.837 212.515 129.811 215.048 126.645C217.581 123.479 217.423 120.84 217.027 119.917C215.972 115.3 213.623 105.115 212.673 101.316C211.724 97.5166 213.069 94.9837 213.861 94.1921L219.797 88.2556Z",
    fill: "#F58120"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M249.402 233H279.481V193.423",
    stroke: "#1E334E",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M277.897 231.417H253.359C256.525 227.855 255.338 229.043 266.024 220.731C274.572 214.083 277.501 203.977 277.897 199.756V231.417Z",
    fill: "#528FF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.803 64.6255C198.035 67.1473 192.99 72.9214 186.95 75.8427C184.712 76.2201 178.336 78.5454 170.736 84.8277L126.041 129.684C124.458 131.46 122.917 135.623 129.414 138.074",
    stroke: "#F58120"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M213.243 79.0503L222.478 88.2853L215.761 95.0016C214.828 95.7479 213.355 98.5277 214.922 103.677L219.119 120.748C219.399 121.96 219.119 125.225 215.761 128.583L199.53 144.815C197.291 147.053 191.974 151.251 185.538 143.695M202.329 125.225L160.351 167.203C157.553 169.815 150.277 172.352 145.799 163.844M145.799 163.844L176.582 133.061M145.799 163.844C144.12 164.591 139.978 165.3 136.844 162.165C132.926 158.247 134.605 154.889 135.165 153.21M135.165 153.21C135.613 151.867 155.874 132.128 165.948 122.427M135.165 153.21C131.154 151.438 124.307 146.27 129.008 139.777M129.008 139.777L156.154 112.632M129.008 139.777C125.37 138.751 119.214 135.02 123.691 128.304L168.467 83.5279C170.519 81.6622 176.638 77.0354 184.698 73.4533C186.284 73.36 191.247 70.9347 198.411 61.9795",
    stroke: "#1E334E",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8151 75.5998L50.9869 101.139C60.0423 108.176 61.4023 112.001 61.518 113.585C65.2135 121.593 69.9263 127.647 71.8207 129.672L117.224 173.811C124.003 178.194 127.647 171.985 128.622 168.333C135.18 172.942 140.251 166.023 141.966 161.987C143.653 162.523 147.035 164.155 150.897 160.182C153.986 157.004 153.219 152.872 152.449 151.204C160.893 146.607 158.253 139.367 155.602 136.606L130.914 112.605C138.378 106.063 134.933 99.9539 132.663 97.7469L116.204 81.7465C112.799 78.4361 109.53 78.2024 108.322 78.4993L91.3119 82.9376C86.1853 84.5773 83.385 83.1428 82.6256 82.2206L75.8151 75.5998Z",
    fill: "#FBFDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6367 85.151L75.7661 75.8116L82.5584 82.4512C83.3152 83.3754 86.1116 84.8176 91.2427 83.192L108.265 78.8005C109.474 78.5069 112.742 78.7496 116.138 82.0694L132.553 98.115C134.817 100.328 139.075 105.597 131.592 112.119M112.933 95.5394L155.385 137.037C158.028 139.805 160.648 147.052 152.192 151.626M152.192 151.626L121.061 121.195M152.192 151.626C152.957 153.297 153.713 157.43 150.615 160.6C146.742 164.562 143.365 162.921 141.679 162.381M141.679 162.381C140.331 161.948 120.363 141.913 110.548 131.949M141.679 162.381C139.953 166.412 134.863 173.317 128.318 168.69M128.318 168.69L100.865 141.855M128.318 168.69C127.333 172.339 123.672 178.538 116.905 174.137L71.623 129.873C69.7342 127.842 65.0381 121.776 61.3646 113.757C61.2533 112.173 58.7717 107.238 49.7357 100.176",
    stroke: "#1E334E",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0599 98.7757C54.6008 100.516 60.4293 105.498 63.4161 111.506C63.8178 113.74 66.2123 120.09 72.5769 127.622L117.917 171.826C119.709 173.389 123.889 174.885 126.269 168.362",
    stroke: "#528FF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.084 229.148L172.703 229.148C171.436 217.75 173.23 214.109 174.286 212.922C177.452 204.69 178.507 197.091 178.639 194.321V130.998C177.056 123.083 170.064 124.798 166.766 126.645C165.5 118.73 157.004 119.917 152.914 121.5C152.123 119.917 150.936 116.355 145.395 116.355C140.962 116.355 138.535 119.785 137.875 121.5C128.694 118.65 125.343 125.589 125.211 129.415V163.847C115.317 163.055 113.338 169.783 113.338 172.949V195.904C113.338 200.653 115.449 203.16 116.504 203.819L131.543 212.922C136.292 215.455 137.216 218.462 137.084 219.65V229.148Z",
    fill: "#FBFDFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.144 229.148H137.084V219.65C137.216 218.462 136.292 215.455 131.543 212.922L116.504 203.819C115.449 203.16 113.338 200.653 113.338 195.904V172.949C113.338 169.783 114.129 163.055 124.024 163.847M125.211 188.78V129.415C125.343 125.589 128.694 118.65 137.875 121.5M137.875 121.5V165.034M137.875 121.5C138.535 119.785 140.962 116.355 145.395 116.355C150.936 116.355 152.123 119.917 152.914 121.5M152.914 121.5C153.548 122.766 153.178 151.05 152.914 165.034M152.914 121.5C157.004 119.917 165.5 118.73 166.766 126.645M166.766 126.645V165.034M166.766 126.645C170.064 124.798 177.056 123.083 178.639 130.998V194.321C178.507 197.091 177.452 204.69 174.286 212.922C173.23 214.109 171.436 219.333 172.703 230.731",
    stroke: "#1E334E",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139.062 226.774H149.748C150.539 224.003 148.956 223.212 147.769 222.816C153.31 197.883 150.935 172.95 151.331 165.826V121.896C150.935 120.708 149.273 118.255 145.79 117.938C142.308 117.622 140.118 120.445 139.458 121.896V165.826H136.292V122.687C129.01 121.421 126.925 126.645 126.794 129.415V189.572H123.628V165.826C116.662 164.876 115.185 169.915 115.316 172.158V197.487C115.316 200.337 117.163 202.104 118.087 202.632C122.176 205.27 131.147 210.943 134.313 212.526C137.479 214.109 138.799 217.407 139.062 218.858V226.774Z",
    fill: "#F58120"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M170.327 229.94C169.8 226.906 169.298 219.254 171.515 212.922C172.833 211.075 175.709 204.927 176.659 195.112V131.79C176.527 129.415 174.68 125.379 168.348 128.228",
    stroke: "#F58120"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.8125,
    y: 175.928,
    width: 57.0902,
    height: 37.0758,
    stroke: "#333333",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27481 212.766L33.3574 191.468L59.4399 212.766H7.27481Z",
    stroke: "#333333",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4384 176.166L33.3558 197.464L7.27324 176.166L33.3558 176.166L59.4384 176.166Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1378 177.788H11.4375L34.7877 196.849L58.1378 177.788Z",
    fill: "#528FF5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8918 146.829C42.8918 152.294 38.462 156.723 32.9977 156.723C27.5333 156.723 23.1035 152.294 23.1035 146.829C23.1035 141.365 27.5333 136.935 32.9977 136.935C38.462 136.935 42.8918 141.365 42.8918 146.829Z",
    fill: "#F58120"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.9968,
    cy: 146.829,
    r: 13.6433,
    stroke: "#333333",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4651 36.2866H18.1426V99.6091",
    stroke: "#1E334E",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5371 37.0781H75.9231C66.1609 39.3208 45.37 47.368 40.3042 61.6156C33.972 79.425 31.9931 86.9446 18.5371 92.8811V37.0781Z",
    fill: "#F58120"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7395 77.9658L67.8242 85.8811C77.006 96.0127 108.852 121.5 123.627 132.977C123.311 129.178 123.759 127.173 124.023 126.645L119.274 121.896L121.648 119.521L125.606 123.479C127.822 119.68 132.07 118.994 133.917 119.125L110.963 96.171L113.337 93.7964L130.355 110.814C136.371 106.382 133.917 101.58 131.938 99.7329C126.529 94.3241 115.158 83.1108 112.941 81.5277C110.725 79.9446 108.852 80.0766 108.192 80.3404C102.652 81.7916 90.9369 84.8521 88.404 85.4854C85.8711 86.1186 83.1271 84.9577 82.0718 84.2981L75.7395 77.9658Z",
    fill: "#528FF5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M195.594 36.0854C195.999 29.3659 194.403 22.6772 191.007 16.865C187.611 11.0528 182.567 6.37814 176.515 3.43222C170.462 0.486294 163.671 -0.598603 157.002 0.31472C150.333 1.22804 144.084 4.09856 139.046 8.56328C134.008 13.028 130.407 18.8864 128.698 25.3976C126.99 31.9089 127.251 38.7805 129.448 45.1436C131.644 51.5067 135.679 57.0754 141.041 61.1456C146.402 65.2157 152.851 67.6045 159.57 68.0099L159.659 66.547C153.228 66.1591 147.058 63.8732 141.927 59.9783C136.796 56.0834 132.935 50.7544 130.833 44.6653C128.731 38.5762 128.481 32.0005 130.116 25.7696C131.751 19.5387 135.197 13.9326 140.018 9.66009C144.839 5.38761 150.819 2.64069 157.201 1.76669C163.583 0.892699 170.081 1.93088 175.873 4.74996C181.666 7.56904 186.492 12.0424 189.742 17.6043C192.991 23.1663 194.519 29.567 194.131 35.9971L195.594 36.0854Z",
    fill: "#1E334E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.281 25.3291H198.946C202.812 25.3291 205.946 28.4631 205.946 32.3291V40.492C205.946 44.358 202.812 47.492 198.946 47.492H193.281L193.677 36.4105L193.281 25.3291Z",
    fill: "#1E334E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M129.958 25.3291H125.086C121.22 25.3291 118.086 28.4631 118.086 32.3291V40.492C118.086 44.358 121.22 47.492 125.086 47.492H130.75L129.958 36.0148V25.3291Z",
    fill: "#1E334E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M166.369 68.0715C166.369 70.6944 164.243 72.8206 161.62 72.8206C158.997 72.8206 156.871 70.6944 156.871 68.0715C156.871 65.4485 158.997 63.3223 161.62 63.3223C164.243 63.3223 166.369 65.4485 166.369 68.0715Z",
    fill: "#F58120"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.523,
    cy: 110.023,
    r: 6.91531,
    stroke: "#F58120",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.175,
    cy: 46.7004,
    r: 3.74919,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.047,
    cy: 231.919,
    r: 6.33225,
    fill: "#1E334E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.005,
    cy: 233.502,
    r: 6.91531,
    stroke: "#F58120",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M196.158 194.215H212.78",
    stroke: "#F58120",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M204.469 185.904L204.469 202.526",
    stroke: "#F58120",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.48,
    cy: 86.3549,
    r: 10.0814,
    stroke: "#528FF5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBg);
export default __webpack_public_path__ + "static/media/help-bg.8d86ad6683264791bb6ada38604253f8.svg";
export { ForwardRef as ReactComponent };